import { render, staticRenderFns } from "./TurnstileWidget.vue?vue&type=template&id=f55da9f8"
import script from "./TurnstileWidget.vue?vue&type=script&lang=js"
export * from "./TurnstileWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports